module.exports = __webpack_public_path__ + "static/fonts/Nexa_Bold.56018b3.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Nexa/Nexa_Bold.otf
// module id = KQcc
// module chunks = 3